import React, { useCallback, useContext } from 'react'
import Particles from 'react-particles'
import { UserContext } from '../../wrappers/UserContext'
import particleConfig from './particleConfig'
import LandingPageNav from './LandingPageNav'
import ReportingLink from './ReportingLink'
import { loadSlim } from 'tsparticles-slim'

const LandingPageWrapper = ({ children }) => {
    const { user } = useContext(UserContext)
    const particlesInit = useCallback(async (engine) => {
        await loadSlim(engine)
    }, [])

    return (
        <>
            <Particles
                id="tsparticles"
                init={particlesInit}
                className={`particlesWrapper ${user ? '' : 'login'}`}
                options={particleConfig}
            />
            {user && <LandingPageNav />}
            <div className="landingPageWrapper">
                <div className="landingPage">
                    <div className="landingPageBanner">
                        <div className="landingPageBannerText is-size-1-desktop is-size-2-tablet is-size-3-mobile">
                            WYDEQ SWM Dashboard
                        </div>
                    </div>
                    {user && <ReportingLink />}
                    <div
                        className={`landingPageContent ${user ? '' : 'short'}`}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </>
    )
}

export default LandingPageWrapper
